import { CustomerPagarMe } from "./customer-pagar-me";
import { ItemPagarMe } from "./item-pagar-me";
import { PaymentPagarMe } from "./payment-pagar-me";

export class OrdersPagarMe {
    items: ItemPagarMe[] = [];
    customer: CustomerPagarMe;
    payments: PaymentPagarMe[] = [];

	constructor() {
	
	}
}